/** First focusable element on the page; jumps keyboard users to <main>. */
export function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only rounded-lg bg-brand-600 px-4 py-2 text-white focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50"
    >
      Skip to main content
    </a>
  );
}
